export default "__VITE_ASSET__CP$hVWXG__"